import { Content, GroupField, ImageField } from '@prismicio/client';
import { Simplify } from '../../../../../prismicio-types';

import styles from './cTAImage.module.scss';
import { OptimizedPrismicImage } from '@/components';

interface CTAImageProps {
  image: ImageField<never>;
  cards: GroupField<Simplify<Content.CallToActionSliceDefaultPrimaryCardsItem>>;
}

export const CTAImage = ({ cards, image }: CTAImageProps) => {
  return (
    <article className={styles.article}>
      <div className={styles.image_box}>
        <div className={styles.image_wrapper}>
          <OptimizedPrismicImage field={image} className={styles.image} />
        </div>
        {cards.map((card, index) => (
          <div
            className={`${styles.card} ${styles[`card-${index}`]}`}
            key={card.text}
          >
            <div className={styles.card_image_wrapper}>
              <OptimizedPrismicImage
                field={card.image}
                className={styles.card_image}
              />
            </div>
            <span className={styles.card_text}>{card.text}</span>
          </div>
        ))}
      </div>
    </article>
  );
};
